import { createContext } from "react"

/** Keep floating controls inside their panel's visibility and focus boundary. */
export const PortalContainerContext = createContext<HTMLElement | null>(null)
